import { render, staticRenderFns } from "./SideMenuListItem.vue?vue&type=template&id=b3ff088a&"
import script from "./SideMenuListItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SideMenuListItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ff088a')) {
      api.createRecord('b3ff088a', component.options)
    } else {
      api.reload('b3ff088a', component.options)
    }
    module.hot.accept("./SideMenuListItem.vue?vue&type=template&id=b3ff088a&", function () {
      api.rerender('b3ff088a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/SideMenuListItem.vue"
export default component.exports